import React from "react";
import { View, Text, StyleSheet } from "react-native";
import { styles } from "../../style/styles.js";

const CustomTitle = ({ title }) => {
  return (
    <View
      style={{
        ...styles.lineTitle,
        backgroundColor: styles.componentColor.backgroundColor,
      }}
    >
      <Text style={[styles.textTitle, styles.textColor]}>{title}</Text>
    </View>
  );
};

export default CustomTitle;
